module.exports = __webpack_public_path__ + "img/ls.4da8ca4f.svg";